import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import * as layouts from "./layouts";
import { Container, Divider, Grid, Typography } from "@material-ui/core";
import LayoutContainer from "../../components/LayoutsContainer";

const Background = "/images/background/SchemesBg.png";
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundImage: `url(${Background})`,
    // background: `url (${Background})`,
    backgroundSize: `100% 150%`,
    backgroundRepeat: "no-repeat",
    height: "75vh",
    paddingTop: theme.spacing(15),
  },
}));

const SubLayouts = ({ data }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <LayoutContainer>
        {/* <Divider /> */}

        {data && (
          <>
            <Grid container spacing={2}>
              {data?.data?.map((layout, index) => {
                const Component = layouts[layout.type];
                return (
                  <Grid item lg={layout?.width || "auto"} key={index}>
                    <Component {...layout} />
                  </Grid>
                );
              })}
            </Grid>
          </>
        )}
      </LayoutContainer>
    </div>
  );
};
export default SubLayouts;
